module.exports = __webpack_public_path__ + "img/more-vert.cd300e48.svg";